import { useHistory } from 'react-router-dom'
import { Box } from '@trybeapp/ui.box'
import { Button as UiButton } from 'ui/components/Button'
import { Text } from '@trybeapp/ui.text'
import { STATUS_CANCELLED } from 'constants/orderStatuses'
import { Col, Row } from '@trybeapp/ui.grid'
import { Card } from '../../../components/Card'
import { StatusTag } from '../Overview'
import { useOrder } from 'contexts/Order'
import { CostColumn } from '../Columns'
import { formatMoney } from 'ui/components/Money'
import { ArrowRightIcon } from '@heroicons/react/solid'

export const MembershipItemRow = ({ item }) => {
  const { status } = useOrder()
  const cancelled = status === STATUS_CANCELLED
  const {
    type_name: name = '',
    total_cost: totalCost,
    discount_amount: discountAmount,
    item_configuration: details = {},
  } = item

  return (
    <Card className="my-2">
      <Card.Body>
        <Row>
          <Col col={0.7} mb="lg">
            <Text as="span" variant="body3" color="nude.700">
              <strong>
                {name} {details.membership_type_name ? `- ${details.membership_type_name}` : ''}
              </strong>
            </Text>
          </Col>
        </Row>
        <Row>
          <Col col={0.13} mb="xs">
            <Text
              variant="meta2"
              color="nude.400"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing="sm"
            >
              Status
            </Text>
          </Col>
          <Col col={0.27} mb="xs">
            <Text
              variant="meta2"
              color="nude.400"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing="sm"
            >
              Joining fee
            </Text>
          </Col>
          <Col col={0.3} mb="xs">
            <Text
              variant="meta2"
              color="nude.400"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing="sm"
            >
              {details?.rate?.billing_frequency === 'P1M' &&
              details?.rate?.default_duration === 'P1M'
                ? 'Monthly fee'
                : 'Pro-rata'}
            </Text>
          </Col>
          <Col col={0.15} mb="xs">
            <Text
              variant="meta2"
              color="nude.400"
              fontWeight="bold"
              textTransform="uppercase"
              letterSpacing="sm"
            >
              Total
            </Text>
          </Col>
          <Col col={0.15} mb="xs"></Col>
        </Row>
        <Row>
          <Col col={0.13}>
            <StatusTag status={status} />
          </Col>
          <Col col={0.27}>
            <span className="text-sm">
              {formatMoney({
                amount: details.joining_fee?.amount ?? 0,
                currency: details.joining_fee?.currency ?? 'gbp',
              })}
            </span>
          </Col>
          <Col col={0.3}>
            <span className="text-sm">
              {formatMoney({
                amount: totalCost + discountAmount - (details.joining_fee?.amount ?? 0),
                currency: details.joining_fee?.currency ?? 'gbp',
              })}
            </span>
          </Col>
          <CostColumn item={item} />
          <Col col={0.4}>
            <Box display="flex" alignItems="center">
              {!cancelled && <GoToMembership />}
            </Box>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

const GoToMembership = () => {
  const order = useOrder()

  const history = useHistory()
  const handleOnClick = () => {
    history.push(`/clients/${order.customer_id}/memberships`)
  }

  return (
    <UiButton
      variant="ghost"
      label="View membership"
      size="xxs"
      onClick={handleOnClick}
      trailingIcon={ArrowRightIcon}
    />
  )
}
